import { Row, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { DateTime } from 'luxon';

import MapPageHeader from "../components/MapPageHeader.jsx";

import RiverDamBlock from './RiverDamBlock.jsx';
import RiverSiteBlock from './RiverSiteBlock.jsx';
import TideSiteBlock from './TideSiteBlock.jsx';

import {
  SITE_TYPE_DAM,
  SITE_TYPE_RIVER,
  SITE_TYPE_TRIBUTARY,
  SITE_TYPE_TIDE,
  SITE_TYPE_TIDE_FORECAST,
} from '../helpers/SiteDataConst.js';

import 'mapbox-gl/dist/mapbox-gl.css';
import styles from './River.module.css';
import BottomBar from '../components/BottomBar.jsx';
import BottomBarArea from '../components/BottomBarArea.jsx';

function River({river, allData}) {
  const {t} = useTranslation();
  const [initialScroll, setInitialScroll] = useState(false);
  const damSites = river?.sites?.filter((site) => site.types.includes(SITE_TYPE_DAM)) || [];
  const riverSites = river?.sites?.filter((site) => site.types.includes(SITE_TYPE_RIVER)) || [];
  const creekSites = river?.sites?.filter((site) => site.types.includes(SITE_TYPE_TRIBUTARY)) || [];
  const tideSites = river?.sites?.filter((site) => site.types.includes(SITE_TYPE_TIDE)) || [];

  function goToSite(siteId) {
    const site = document.getElementById(siteId);
    site.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  useEffect(() => {
    if (!initialScroll) {
      const hash = window.location.hash;
      if (hash) {
        const site = document.getElementById(hash.slice(1));
        if (site) {
          site.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setInitialScroll(true);
        }
      }
    }
  }, [river, initialScroll, setInitialScroll]);

  return (
    <>
      <div className={styles.RiverPage}>
        <MapPageHeader riverKey={river?.key} geometry={river?.geometry} sites={river?.sites} allData={allData} pageTitle={river?.name} goToSite={goToSite} />
        <div className={styles.RiverPageContent}>
          <Container>
            {damSites.map((site) => {
              return (
                <RiverDamBlock key={site.id} site={site} allData={allData}/>
              );
            })}
            {(riverSites.length > 0) && (
              <>
                <h2>River Conditions</h2>
                <Row>
                  {riverSites.map((site) => {
                    return (
                      <RiverSiteBlock key={site.id} site={site} allData={allData} colSize={ColumnSize(riverSites.length)} />
                    );
                  })}
                </Row>
              </>
            )}
            {(creekSites.length > 0) && (
              <>
                <h2>Creek and Tributary Conditions</h2>
                <Row>
                  {creekSites.map((site) => {
                    return (
                      <RiverSiteBlock key={site.id} site={site} allData={allData} colSize={ColumnSize(creekSites.length)} />
                    );
                  })}
                </Row>
              </>
            )}
            {tideSites.length > 0 && (
              <>
              <h2>Tidal Conditions</h2>
              {tideSites.map((site) => {
                return (<TideSiteBlock key={site.id} site={site} allData={allData} />);
              })}
              </>
            )}
          </Container>
        </div>
      </div>

      <BottomBarArea>
        {allData?.warnings.map((warning => DateTime.fromISO(warning.validity_end_timestamp) > DateTime.now() && (
          <BottomBar
            key={warning.productId}
            message={warning.title}
            link={river?.warning_link}
            severity={'warning'}
          />
        )))}
        {allData?.watches.map((watch => DateTime.fromISO(watch.validity_end_timestamp) > DateTime.now() && (
          <BottomBar
            key={watch.productId}
            message={watch.title}
            link={river?.watch_link_pattern?.replace('{$product_id}', watch.productId)}
            severity={'watch'}
          />
        )))}
      </BottomBarArea>
    </>
  );
}


function ColumnSize(listSize) {
  if (listSize % 3 == 0) {
    return { xs: 12, md: 6, lg: 4 };
  } else if (listSize % 2 == 0 || listSize == 1) {
    return { xs: 12, md: 6, lg: 6 };
  } else {
    return { xs: 12, md: 6, lg: 4 };
  }
}

export default River
